import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { NeuSelect } from "../../components/neu/Neu";
import { ADMIN_ROLES } from "../../utils/role";

// تتالي اختيار المعاقَب: الفرع ← القسم ← الموظف (يضيّق كل مستوى ما بعده).
export const PenaltyAudience = ({ branches = [], departments = [], employees = [], value, onPick }) => {
  const { t } = useTranslation();
  const [branch, setBranch] = useState("");
  const [dept, setDept] = useState("");
  const name = (o) => o.name_ar || o.name || o.name_en || o.email || o.id;

  const depts = useMemo(
    () => departments.filter((d) => !branch || !d.branch_id || d.branch_id === branch),
    [departments, branch]
  );
  const emps = useMemo(
    () =>
      employees.filter(
        (e) =>
          !ADMIN_ROLES.includes(e.hierarchy_role || e.role) &&
          (!branch || (e.branch_ids || []).includes(branch)) &&
          (!dept || (e.department_ids || []).includes(dept))
      ),
    [employees, branch, dept]
  );

  return (
    <>
      <label className="grid gap-1 text-xs font-bold">
        {t("penalty.fields.branch")}
        <NeuSelect data-testid="penalty-branch-select" value={branch}
                   onChange={(e) => { setBranch(e.target.value); setDept(""); onPick(""); }}>
          <option value="">{t("penalty.pickBranch")}</option>
          {branches.map((b) => <option key={b.id} value={b.id}>{name(b)}</option>)}
        </NeuSelect>
      </label>
      <label className="grid gap-1 text-xs font-bold">
        {t("penalty.fields.department")}
        <NeuSelect data-testid="penalty-department-select" value={dept}
                   onChange={(e) => { setDept(e.target.value); onPick(""); }}>
          <option value="">{t("penalty.pickDepartment")}</option>
          {depts.map((d) => <option key={d.id} value={d.id}>{name(d)}</option>)}
        </NeuSelect>
      </label>
      <label className="grid gap-1 text-xs font-bold">
        {t("penalty.fields.employee")}
        <NeuSelect data-testid="penalty-employee-select" value={value} onChange={(e) => onPick(e.target.value)}>
          <option value="">{t("penalty.pickEmployee")}</option>
          {emps.map((e) => <option key={e.id} value={e.id}>{name(e)}</option>)}
        </NeuSelect>
      </label>
    </>
  );
};
